<template>
  <v-container fluid>
    <v-card class="ma-3"
      ><v-container>
        <h1 class="mx-auto mt-5">About</h1>
        <br />
        welcome to roll play stage!<br /><br />
        <br /><br />
        <br /><br />. <br /><br />
        Thank you for taking the time to visit my site! <br /><br />

        If you would like to get in touch please shoot me an email, or reach out
        using one of the other links below:

        <h4 class="ma-2">Say Hello!</h4>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "about",
  components: {},
  computed: {},
  data() {
    return {};
  },
};
</script>

<style scoped>
.content-text >>> p {
  /* color: red; */
  line-height: 1px;
  margin: 10px 0;
}
.content-text {
  font-size: 16px;
  font-weight: 250;
}
</style>